import { NgModule } from '@angular/core';
import { ToLocalStringPipe } from '@utils/pipes/to-local-string.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { ToLocalDateTimePipe } from '@utils/pipes/to-local-date-time.pipe';
import { SafeResourceUrlPipe } from './safe-resource-url.pipe';
import { CapitalizeFirstPipe } from './capitalizeFirst.pipe';
import { FirstValidationErrorPipe } from './first-validation-error';

export * from '@utils/pipes/to-local-string.pipe';
export * from '@utils/pipes/to-local-date-time.pipe';
export * from '@utils/pipes/first-validation-error';
@NgModule({
  providers: [],
  declarations: [ToLocalStringPipe, ToLocalDateTimePipe, SafeHtmlPipe, SafeResourceUrlPipe, CapitalizeFirstPipe, FirstValidationErrorPipe],
  exports: [ToLocalStringPipe, ToLocalDateTimePipe, SafeHtmlPipe, SafeResourceUrlPipe, CapitalizeFirstPipe, FirstValidationErrorPipe]
})
export class PipesModule {}
